export default "__VITE_ASSET__656efb7c__"